import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function StatusWarningFilledIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        d="M11.223 2.063a5 5 0 0 1 1.553 0c1.301.204 2.288 1.06 3.216 2.238.925 1.175 1.931 2.858 3.208 4.987 1.342 2.239 2.4 4 3.027 5.43.626 1.428.926 2.75.453 4.023-.185.5-.45.967-.783 1.383-.848 1.06-2.137 1.483-3.683 1.68C16.666 22.003 14.61 22 12 22s-4.666.002-6.214-.195c-1.547-.198-2.835-.62-3.684-1.68a5 5 0 0 1-.783-1.384c-.473-1.273-.173-2.595.453-4.023.627-1.43 1.685-3.191 3.027-5.43 1.277-2.13 2.283-3.812 3.208-4.987.928-1.178 1.915-2.034 3.216-2.238M12 15a1.125 1.125 0 1 0 0 2.25A1.125 1.125 0 0 0 12 15m0-8a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1"
        clipRule="evenodd"
      />
    </Icon>
  );
}

StatusWarningFilledIcon.displayName = 'StatusWarningFilledIcon';
